var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4096",
    "data-name": "Group 4096",
    transform: "translate(-671 -491)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_454",
    "data-name": "Ellipse 454",
    cx: 3,
    cy: 2.5,
    rx: 3,
    ry: 2.5,
    transform: "translate(671 491)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2685",
    "data-name": "Rectangle 2685",
    width: 1,
    height: 9,
    transform: "translate(673 493)",
    fill: "#e27867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b212f367e302dc9b31f6330231a1194b.svg";
export { ForwardRef as ReactComponent };